<div class="card">
	<div class="card-header">
		<h1>Realizar inventario</h1>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col form-group">
				<label for="warehouse" class="form-label">Bodega</label>
				<div class="input-group">
					<app-input-autocomplete [ruleToDisabled]="loading" [inputs]="warehouse"
						(inputMethod)="writeWarehouse()" [filterElements]="warehouse.filterElements"
						(changeStatus)="selectWarehouse($event.filterElement)" placeholder="Selecciona una bodega"
						[padding]="0" [custom]="true" [allBorderRadius]="true">
						<ng-template #itemsTemplate let-filter>
							<div class="suggestion-item-custom">
								<span class="h5"><b>{{filter.name}}</b></span>
								<br style="margin: 0;">
								<span>NIT: <b>{{filter.nit?filter.nit:'--'}}</b> Código: <b>{{filter.code}}</b></span>
							</div>
						</ng-template>
					</app-input-autocomplete>
				</div>
			</div>
			<div class="col form-group">
				<label for="product" class="form-label">Producto</label>
				<div class="input-group">
					<app-input-autocomplete [ruleToDisabled]="loading || !warehouse.data"
						(changeStatus)="selectProduct($event.filterElement)" [inputs]="product"
						(inputMethod)="writeProduct()" [filterElements]="product.filterElements"
						placeholder="Selecciona un producto" [padding]="0" [custom]="true" [allBorderRadius]="true">
						<ng-template #itemsTemplate let-filter>
							<div class="suggestion-item-custom">
								<span class="h5"><b>{{filter.name}}</b></span>
								<br style="margin: 0" *ngIf="counted[filter.id] && counted[filter.id].user 
								&& (counted[filter.id].systemStock - counted[filter.id].physicalStock) != 0">
								<span *ngIf="counted[filter.id] && counted[filter.id].user 
								&& (counted[filter.id].systemStock - counted[filter.id].physicalStock) != 0" 
								style="color: darkolivegreen;">
									<i class="fa fa-triangle-exclamation"></i>
									Diferencias en conteo: <b>{{counted[filter.id].systemStock -
										counted[filter.id].physicalStock}}</b>
									Día de conteo: <b>{{counted[filter.id].counted | date: 'dd/MM/YYYY'}}</b>
									Contado por: <b>{{counted[filter.id].user.email}}</b>
								</span>
								<br style="margin: 0;">
								<span>Barras: <b>{{filter.barCode?filter.barCode:'--'}}</b> Código:
									<b>{{filter.code}} </b>
								</span>
							</div>
						</ng-template>
					</app-input-autocomplete>
				</div>
			</div>
		</div>
		<br>
		<div *ngIf="list.length == 0">
			<div class="row" style="color: var(--bs-bg-servicios)">
				<div class="col-sm-10">
					<span class="display-4"> Ingresa productos para poder realizar el inventario.
					</span>
				</div>
				<div class="col-sm-2" style="display: flex; flex-direction: row; justify-content: center;">
					<span class="display-2"
						style="display: flex; justify-content: center; flex-direction: row; align-items: center;">
						<i class="fa fa-hand-pointer bouncing-hand"></i>
					</span>
				</div>
			</div>
		</div>
		<div class="table-responsive" *ngIf="list.length > 0">
			<table class="table table-bordered">
				<thead>
					<tr class="tr-middle tr-custom">
						<th colspan="2">Códigos</th>
						<th rowspan="2">Nombre</th>
						<th rowspan="2">Unidades físicas</th>
						<th rowspan="2">Unidades sistema</th>
						<th rowspan="2" style="border: none;"></th>
					</tr>
					<tr class="tr-middle">
						<th>de Barras</th>
						<th>Producto</th>
					</tr>
				</thead>
				<tbody>
					<tr class="tr-middle" *ngFor="let product of list; let i = index;">
						<td>
							{{product.barCode}}
							<div class="superposition-parent" *ngIf="!product.barCode">
								<i class="fa fa-barcode"></i>
								<i class="fa fa-question superposition-icon"></i>
							</div>
						</td>
						<td>
							{{product.code}}
						</td>
						<td>
							{{product.name}}
						</td>
						<td>
							<div class="field">
								<div class="input-group">
									<input type="text" (input)="calc(product)" [(ngModel)]="product.calc"
										placeholder="Ingresa unidades o expresión matemática (p. ej. 5+8)"
										class="form-control">
									<span class="input-group-text">
										<ng-container *ngIf="product.units !== null && product.calc">
											{{product.units}}
										</ng-container>
										<ng-container *ngIf="!product.calc">
											<i class="fa fa-question"></i>
										</ng-container>
										<ng-container *ngIf="product.units === null && product.calc">
											<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
											<span role="status"></span>
										</ng-container>
									</span>
								</div>
								<span class="field-span">
									<i class="fa fa-boxes"></i> Unidades
								</span>
							</div>
						</td>
						<td>
							{{product.existences}}
						</td>
						<td>
							<i class="fa fa-trash clickeable text-danger" (click)="removeProduct(i, product)"></i>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<app-loading-button style="width: 100%;" [disabled]="verifiedSave()" [colorLoading]="'white'"
			*ngIf="list.length > 0" [logo]="true" [object]="buttonSave" (clicked)="save()"></app-loading-button>
		<p style="font-size: 0.9em; color: gray; opacity: 0.5; text-align: center;" *ngIf="verifiedSave()">
			<i class="fa fa-circle-info"></i>
			Faltan campos por rellenar
		</p>
	</div>
</div>
<app-simple-modal [title]="'Resultado'" *ngIf="result" [requiredFields]="false" (close)="this.result = null">
	<div fields>
		<div class="table-responsive">
			<table class="table table-bordered">
				<thead>
					<tr class="tr-middle">
						<th colspan="2">Códigos</th>
						<th rowspan="2">Nombre</th>
						<th rowspan="2">Unidades físicas</th>
						<th rowspan="2">Unidades sistema</th>
						<th rowspan="2">Estado</th>
						<th rowspan="2">Diferencia</th>
						<th rowspan="2">Costo</th>
					</tr>
					<tr class="tr-middle">
						<th>de Barras</th>
						<th>Producto</th>
					</tr>
				</thead>
				<tbody>
					<tr class="tr-middle" *ngFor="let product of result.listExistences">
						<td>
							{{product.productData.barCode}}
							<div class="superposition-parent" *ngIf="!product.productData.barCode">
								<i class="fa fa-barcode"></i>
								<i class="fa fa-question superposition-icon"></i>
							</div>
						</td>
						<td>
							{{product.productData.code}}
						</td>
						<td>
							{{product.productData.name}}
						</td>
						<td>
							{{product.physicalStock}}
						</td>
						<td>
							{{product.systemStock}}
						</td>
						<td>
							<ng-container *ngIf="product.difference > 0">
								{{product.sale?'Venta':'Compra'}} {{product.alreadyCounted?'contada':'no contada'}} y
								{{product.alreadySaved?'guardada':'gin guardar'}}
							</ng-container>
							<span *ngIf="product.difference == 0">
								Contado
							</span>
						</td>
						<td>
							{{product.difference}}
						</td>
						<td>
							{{product.cost | currency:'Q'}}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="table-responsive" *ngIf="result.clientInvoice">
			<table class="table table-bordered">
				<thead>
					<tr class="tr-middle title-fact">
						<th colspan="3">
							<i class="fa fa-file-invoice-dollar"></i>
							Información de factura generada
						</th>
					</tr>
					<tr class="tr-middle sub-title-fact">
						<th>Serie</th>
						<th>Número</th>
						<th>Total</th>
					</tr>
				</thead>
				<tbody>
					<tr class="tr-middle">
						<td>
							{{result.clientInvoice.data.invoiceData.series}}
						</td>
						<td>
							{{result.clientInvoice.data.invoiceData.number}}
						</td>
						<td>
							{{result.clientInvoice.data.invoiceData.totalCost +
							result.clientInvoice.data.invoiceData.totalTaxes | currency: 'Q'}}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</app-simple-modal>